import {
	SELLERSIGNFN
} from './mutation-types.js'
import { querySellerSign } from "../api/public";
export default {
	async getSellerSignData({
		commit,
	}) {
		let res = await querySellerSign({});
		commit(SELLERSIGNFN, res.data.dataList);
	},
  //存储登录状态
  updateUserInfo({ commit }, data) {
    commit('setUserInfo', data);
  },
   //存储活跃菜单
  updateActiveMenu({ commit }, data) {
    commit('setActiveMenu', data);
  },
   //存储一级菜单
   updateFistMenuList({ commit }, data) {
    commit('setFistMenuList', data);
  },
  updateChildMenuList({ commit }, data) {
    commit('setChildMenuList', data);
  },
}